import { render } from "./ErrorDialogComponent.vue?vue&type=template&id=ec08e5d4&ts=true"
import script from "./ErrorDialogComponent.vue?vue&type=script&lang=ts"
export * from "./ErrorDialogComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src186264411/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__